export class HotelModel {
         public id: number;
         public title: string;
         public intro_text: string;
         public phone: string;
         public address: string;
         public email: string;
         public fees_notice: string;
         public mention_notice: string;
         public check_in: string;
         public check_out: string;
         public is_pet_allow: number;
         public hotel_star: number;
         public is_free_cancel: number;
         public is_reservation_without_creadit_card: number;
         public is_no_prepayment: number;
         public can_exchange_currency: number;
         public currency: string;
         public timezone: string;

         constructor(obj: any) {
           this.id = obj.id ? obj.id : 0;
           this.title = obj.title ? obj.title : "";
           this.intro_text = obj.intro_text ? obj.intro_text : "";
           this.phone = obj.phone ? obj.phone : "";
           this.address = obj.address ? obj.address : "";
           this.email = obj.email ? obj.email : "";
           this.fees_notice = obj.fees_notice ? obj.fees_notice : "";
           this.mention_notice = obj.mention_notice ? obj.mention_notice : "";
           this.check_in = obj.check_in ? obj.check_in : "";
           this.check_out = obj.check_out ? obj.check_out : "";
           this.is_pet_allow = obj.is_pet_allow ? obj.is_pet_allow : "";
           this.hotel_star = obj.hotel_star ? obj.hotel_star : "";
           this.is_free_cancel = obj.is_free_cancel ? obj.is_free_cancel : "";
           this.is_reservation_without_creadit_card = obj.is_reservation_without_creadit_card
             ? obj.is_reservation_without_creadit_card
             : "";
           this.is_no_prepayment = obj.is_no_prepayment
             ? obj.is_no_prepayment
             : "";
           this.can_exchange_currency = obj.can_exchange_currency
             ? obj.can_exchange_currency
             : "";
           this.currency = obj.currency ? obj.currency : "";
           this.timezone = obj.timezone ? obj.timezone : "";
         }
       }
